import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { PaymentService } from '../services/payment/payment.service';
import { SharedService } from '../services/shared/shared.service';
declare var $: any;

@Component({
  selector: 'app-operator-incentive-report',
  templateUrl: './operator-incentive-report.component.html',
  styleUrls: ['./operator-incentive-report.component.css']
})
export class OperatorIncentiveReportComponent implements OnInit {
  calendarOptions: NgxDrpOptions; customDateFormat = "";
  accounts: any[] = []; accountId = null; orgId = null;
  incentiveReports: any[] = []; screeningCenters: any[] = [];
  range: Range = { fromDate: new Date(), toDate: new Date() };
  presets: Array<PresetItem> = []; options: NgxDrpOptions;
  landingFrom:String;
  landedFromUserId:String=null;
  exportedByRole:String="Super Admin";

  constructor(private foruscareService: ForuscareService, private accountService: AccountService,
    private paymentService: PaymentService, private sharedService : SharedService,private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
    /*start : manage iframe landing page */
    this.sharedService.tokenIfCalledFromOtherApp = null;
    this.activatedRoute.params.subscribe((params: Params)=>{
      let request = params["requestObj"];
      request = JSON.parse(request);
      this.landingFrom = request.landingFrom
      this.sharedService.tokenIfCalledFromOtherApp = request.token;
      this.accountId = request.accountId;
      this.orgId = request.orgId;
      this.landedFromUserId = request.userId;
      this.exportedByRole = request.exportedByRole;
      this.customDateFormat = request.dateFormat.replace(/--/g,"/");
    });
    if(this.landingFrom == "dhp"){
      $('.page-topbar').hide();
      $('.page-sidebar').hide();
      $('#main-content').css('margin-left','0px');
      $('#content-wrapper').css("padding","0 0 0 0");
      $('.main-wrapper').css("margin-top","0px");
      this.updateSelectedAccount();
      this.customDateFormat = (this.customDateFormat!=null?this.customDateFormat:"dd-MM-yyyy HH:mm tt");
    }
    else{
      $('.page-topbar').show();
      $('.page-sidebar').show();
      $('#content-wrapper').css("padding","30px 20px 0 20px");
      $('.main-wrapper').css("margin-top","60px");
      this.customDateFormat = this.foruscareService.getDateFormat();
      //$('#main-content').css('margin-left','200px');
    }
    /*end : manage iframe landing page */
    const today = new Date();
    const fromMin = new Date(today.getFullYear(), today.getMonth() - 2, 1);
    const fromMax = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const toMin = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const toMax = new Date(today.getFullYear(), today.getMonth() + 2, 0);

    this.setupPresets();
    this.options = {
      presets: this.presets,
      //format: 'mediumDate',
      format: this.customDateFormat.split(" ")[0],
      range: { fromDate: today, toDate: today },
      applyLabel: "Submit",
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
        hasBackdrop: false
      }
    };
    if(this.landingFrom != "dhp"){
      this.getAvailableAccounts();
    }
  }

  updateSelectedAccount() {
    if(this.landingFrom == "dhp" && this.exportedByRole.toLocaleLowerCase()=="screening center manager"){
      this.accountService.getCMCentersByUserId(this.landedFromUserId)
    .subscribe(response=>{
      if(response.errorCode==200){
        this.screeningCenters = response.data;
      }
    },error=>{});
    }
    else if (this.accountId != null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe((response: any) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.screeningCenters = response.data;
            }
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
          }
        });
    }
    
    this.getIncentiveReportsByAccountOrgId();
  }

  exportIncentiveReport() {
    alert("yet to integrate API");
  }

  getIncentiveReportsByAccountOrgId() {
    if (this.range.fromDate != null && this.range.toDate != null &&
      this.accountId != null && this.accountId > 0) {
      this.incentiveReports = [];
      this.paymentService.getIncentiveReportsByAccountOrgId(this.accountId, this.orgId,
        this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate))
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.incentiveReports = response.data;
            }
          }
          else {
            //this.foruscareService.showNotification(response.message, "danger");
            this.foruscareService.showNotification("No records found for selected date range. Please select a different date range and try again.", "danger");
          }
        });
    }
  }

  updateRange(range: Range) {
    this.range = range;
    this.getIncentiveReportsByAccountOrgId();
  }

  setupPresets() {
    const backDate = (numOfDays) => {
      const today = new Date();
      return new Date(today.setDate(today.getDate() - numOfDays));
    }

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7)
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: "Yesterday", range: { fromDate: yesterday, toDate: yesterday } },
      { presetLabel: "Last 7 Days", range: { fromDate: minus7, toDate: today } },
      { presetLabel: "Last 30 Days", range: { fromDate: minus30, toDate: today } },
      { presetLabel: "This Month", range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: "Last Month", range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ]
  }


  getScreeningCentersByAccountID(): void {
    if (this.accountId !== null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe((response: any) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.screeningCenters = response.data;
            }
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
          }
        });
    }
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) { 
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getUserTypeString(userType){
    switch(userType){
      case "DIGITAL_EYE_MITRA": return "Digital EyeMitra";
      case "REGULAR_EYE_MITRA": return "Regular EyeMitra";
      default: return "NA";
    }
  }
  downloadXLS():void{
    this.accountService.exportIncentiveReportXLS(
      {'startDate' : this.foruscareService.getDateForServerAPI(this.range.fromDate) ,
       'endDate' : this.foruscareService.getDateForServerAPI(this.range.toDate), 
       "accountId":this.accountId ,
       "orgId":this.orgId,
       "userId":(this.landedFromUserId!=null?this.landedFromUserId:parseInt(this.sharedService.getLoggedInUserId())),
       "dateFormat":this.customDateFormat,
       "exportedByRole":this.exportedByRole
      }).subscribe(response => {
      if( response.status == 200 ) {
        let blob = new Blob([response.body], { type: 'application/octet-stream'});
        var link = document.createElement('a');
        link.style.display = "none";
        link.href = window.URL.createObjectURL(blob);
        link.download = 'incentive_report_'+this.foruscareService.getDateForServerAPI(this.range.fromDate)+'_to_'+this.foruscareService.getDateForServerAPI(this.range.toDate)+'.xlsx';
        link.click();
      } else{
          this.foruscareService.showNotification("File download failed","danger");
      }
    });
  }


}
